import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M15 1H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zM5.5 3h8c.275 0 .5.225.5.5s-.225.5-.5.5h-8c-.275 0-.5-.225-.5-.5s.225-.5.5-.5zM16 17c0 .551-.449 1-1 1H4c-.551 0-1-.449-1-1V6h13v11z',
    'M13.5 8h-8c-.275 0-.5.225-.5.5v6c0 .275.225.5.5.5h8c.275 0 .5-.225.5-.5v-6c0-.275-.225-.5-.5-.5zm-.5 3v1H6v-1h7zm-7 2h7v1H6v-1zm7-4v1H6V9h7z',
  ],
  height: 20,
  width: 20,
});
